export const FIFITY_PER_CENT_TAX = 1;
export const HUNDRED_PER_CENT_TAX = 2;
export const NO_TAX = 0;

export const CANCELLATION_ENUM = 1;
export const EXTENSION_ENUM = 2;

export const TAX_TYPE = {
  [FIFITY_PER_CENT_TAX]: '50%',
  [HUNDRED_PER_CENT_TAX]: '100%',
};

export const ADDENDUM_TYPE = {
  CANCELLATION: CANCELLATION_ENUM,
  EXTENSION: EXTENSION_ENUM,
};
